var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import TextField from '../../components/FormComponents/TextField';
import CloseIcon from '@mui/icons-material/Close';
import './../../assets/scss/adminview.scss';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import AutoCompleteMultiSelectDD from '../../components/FormComponents/AutoCompleteMulitSelectDD';
import constants from '../../config/constants';
import { utility } from '../../utils';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
var initialDealerProgramInfo = {
    SearchBy: 'DealerId',
    DealerAccountAspireOId: '',
    DealerAccountAspireId: '',
    DealerName: '',
    Status: '',
    ProgramNames: ''
};
var DealerProgramAssocation = function (_a) {
    var _b, _c, _d;
    var open = _a.open, handleClose = _a.handleClose, rowData = _a.rowData, userAction = _a.userAction, DealerProgramAssociationList = _a.DealerProgramAssociationList, _e = _a.canUpdate, canUpdate = _e === void 0 ? true : _e;
    var _f = React.useState(__assign({}, initialDealerProgramInfo)), dealerProgramInfo = _f[0], setDealerProgramInfo = _f[1];
    var _g = useState(''), rerender = _g[0], setRerender = _g[1];
    var _h = React.useState(__assign({}, initialDealerProgramInfo)), errors = _h[0], setErrors = _h[1];
    var _j = React.useState(''), actionType = _j[0], setActionType = _j[1];
    var _k = useState(false), openConfirmationPopup = _k[0], setOpenConfirmationPopup = _k[1];
    var _l = useState(false), openSuccessPopup = _l[0], setOpenSuccessPopup = _l[1];
    var _m = React.useState([]), programsList = _m[0], setProgramsList = _m[1];
    var _o = React.useState(false), isSyncing = _o[0], setIsSyncing = _o[1];
    var handleNewLocationInfoChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setErrors(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[name] = '', _a)));
        });
        setDealerProgramInfo(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
        });
    };
    var handleOnInputBlur = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        var updatedErrors = __assign({}, errors);
        updatedErrors[name] = validateField(name, name === 'ProgramNames' ? dealerProgramInfo.ProgramNames : value);
        if ((name === 'DealerAccountAspireOId' || name === 'DealerAccountAspireId') && !updatedErrors[name]) {
            getDealerNameBasedOnOID(value);
        }
        setErrors(updatedErrors);
    };
    var validateField = function (name, value) {
        var _a;
        if (name === 'ProgramNames') {
            if (!value || !((_a = value[0]) === null || _a === void 0 ? void 0 : _a.label)) {
                return 'This field is required.';
            }
            return '';
        }
        if (name === 'DealerAccountAspireOId') {
            if (!value) {
                return 'This field is required.';
            }
            return constants.regex.onlyNumeric.test(value) ? '' : 'Please enter a numeric value.';
        }
        if (name === 'DealerAccountAspireId') {
            if (!value) {
                return 'This field is required.';
            }
        }
        return '';
    };
    var isValidData = function () {
        var updatedErrors = __assign({}, errors);
        for (var key in dealerProgramInfo) {
            var error = validateField(key, dealerProgramInfo[key]);
            updatedErrors[key] = error;
        }
        setErrors(updatedErrors);
        var hasErrors = Object.values(updatedErrors).some(function (val) { return val !== ''; });
        return !hasErrors;
    };
    var handleClick = function () {
        if (actionType === 'View') {
            setActionType('Edit');
        }
        else if (actionType === 'Edit' || actionType === 'Create') {
            if (isValidData()) {
                setOpenConfirmationPopup(true);
            }
        }
        else {
            return;
        }
    };
    var handleDrawerClose = function () {
        setActionType('');
        setDealerProgramInfo(__assign({}, initialDealerProgramInfo));
        setErrors(__assign({}, initialDealerProgramInfo));
        handleClose();
        setErrors(__assign({}, initialDealerProgramInfo));
    };
    var getDealerNameBasedOnOID = function (value) {
        var __payload = {};
        if (dealerProgramInfo.SearchBy == 'DealerId') {
            __payload.DealerAccountAspireId = value;
        }
        else {
            __payload.DealerAccountAspireOId = value;
        }
        api_service.get({
            endPoint: api_urls.GET_DEALER_NAME,
            payLoad: __payload
        }).then(function (res) {
            var _a;
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                setDealerProgramInfo(function (prevState) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return (__assign(__assign({}, prevState), { DealerName: (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Name, DealerAccountAspireOId: (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.DealerAccountAspireOId, DealerAccountAspireId: (_f = (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.DealerAccountAspireId, Status: (_h = (_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.Status }));
                });
                setRerender(JSON.stringify(Date.now()));
            }
        }).catch(function (err) {
            console.log('getDealerNameBasedOnOID ~ err:', err);
        });
    };
    var getProgramList = function () {
        api_service.get({
            endPoint: api_urls.PROGRAMS_LIST,
        }).then((function (res) {
            var _a;
            if (res.data && res.data.statusCode === 200) {
                var response = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                if (response) {
                    var programOptions = response.map(function (programObj) { return ({
                        label: programObj.Name,
                        value: programObj.Id
                    }); });
                    setProgramsList(programOptions);
                }
            }
            else {
                console.log('res error', res.data);
            }
        })).catch(function (error) {
            console.log('Error:', error);
        });
    };
    var handleUpdateAdmin = function () {
        var __programIds = getPayloadProgramIds();
        var __payload = {
            DealerName: dealerProgramInfo.DealerName,
            DealerOId: dealerProgramInfo.DealerAccountAspireOId,
            DealerAccountAspireId: dealerProgramInfo.DealerAccountAspireId,
            ProgramIds: __programIds
        };
        api_service.put({
            endPoint: api_urls.CREATE_DEALER_PROG_ASSOCIATION,
            payLoad: __payload,
            showLoader: true
        }).then(function (res) {
            var _a;
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                setOpenSuccessPopup(true);
            }
            else {
                utility.alert((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message);
            }
        }).catch(function (err) {
            console.log('getDealersList ~ err:', err);
        });
    };
    var getPayloadProgramIds = function () {
        var __programNames = __spreadArray([], dealerProgramInfo.ProgramNames, true);
        var __programIds = __programNames.map(function (item) {
            return Number(item.value);
        });
        return __programIds;
    };
    var handleCreateDealerProgramAssociation = function () {
        var __programIds = getPayloadProgramIds();
        var __payload = {
            DealerName: dealerProgramInfo.DealerName,
            DealerOId: dealerProgramInfo.DealerAccountAspireOId,
            DealerAccountAspireId: dealerProgramInfo.DealerAccountAspireId,
            ProgramIds: __programIds
        };
        api_service.post({
            endPoint: api_urls.CREATE_DEALER_PROG_ASSOCIATION,
            payLoad: __payload,
            showLoader: true
        }).then(function (res) {
            var _a;
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                setOpenSuccessPopup(true);
            }
            else {
                utility.alert((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message);
            }
        }).catch(function (err) {
            console.log('handleCreateDealerProgramAssociation ~ err:', err);
        });
    };
    var getButtonText = function () {
        if (userAction === 'Create') {
            return 'Add';
        }
        else {
            return actionType === 'View' ? 'Edit' : 'Save';
        }
    };
    var handleSelectionChange = function (event, values) {
        setErrors(function (prevState) { return (__assign(__assign({}, prevState), { ProgramNames: '' })); });
        setDealerProgramInfo(function (prevState) { return (__assign(__assign({}, prevState), { ProgramNames: values })); });
    };
    var getSyncedData = function (dealerProgramInfoData) {
        var __payload = {};
        if (dealerProgramInfo.SearchBy == 'DealerId') {
            __payload.DealerId = rowData === null || rowData === void 0 ? void 0 : rowData.DealerAccountAspireId;
        }
        else {
            __payload.DealerOId = rowData === null || rowData === void 0 ? void 0 : rowData.DealerAccountAspireOId;
        }
        setIsSyncing(true);
        api_service.get({
            endPoint: api_urls.SYNC_DEALER_PROG_ASSOCIATION,
            payLoad: __payload
        }).then((function (res) {
            var _a;
            setIsSyncing(false);
            if (res.data && res.data.statusCode === 200) {
                var response = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                if (response) {
                    var __dealerProgramInfo = __assign({}, dealerProgramInfo);
                    if (dealerProgramInfoData) {
                        __dealerProgramInfo = __assign(__assign({}, __dealerProgramInfo), dealerProgramInfoData);
                    }
                    __dealerProgramInfo.DealerName = response.DealerName;
                    __dealerProgramInfo.Status = response.Status;
                    __dealerProgramInfo.ActivationCode = response.ActivationCode;
                    if (dealerProgramInfo.SearchBy == 'DealerId') {
                        if (response.DealerAccountAspireOId !== undefined && response.DealerAccountAspireOId !== null) {
                            __dealerProgramInfo.DealerAccountAspireOId = response.DealerAccountAspireOId;
                        }
                    }
                    else {
                        if (response.DealerAccountAspireId !== undefined && response.DealerAccountAspireId !== null) {
                            __dealerProgramInfo.DealerAccountAspireId = response.DealerAccountAspireId;
                        }
                    }
                    setDealerProgramInfo(__dealerProgramInfo);
                }
            }
            else {
                console.log('res error', res.data);
            }
        })).catch(function (error) {
            setIsSyncing(false);
            console.log('Error:', error);
        });
    };
    useEffect(function () {
        getProgramList();
    }, []);
    useEffect(function () {
        setActionType(userAction);
    }, [userAction]);
    useEffect(function () {
        var _a, _b;
        if (actionType === 'Create') {
            setDealerProgramInfo(__assign({}, initialDealerProgramInfo));
        }
        else {
            var __programIds = (rowData === null || rowData === void 0 ? void 0 : rowData.ProgramNames) && ((_b = (_a = rowData === null || rowData === void 0 ? void 0 : rowData.ProgramNames) === null || _a === void 0 ? void 0 : _a.split(',')) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                var _selectedProgram = programsList === null || programsList === void 0 ? void 0 : programsList.find(function (program) { return program.label == item; });
                return _selectedProgram ? { label: _selectedProgram.label, value: _selectedProgram.value } : null;
            }).filter(Boolean));
            setDealerProgramInfo(__assign(__assign({}, rowData), { ProgramNames: __programIds, SearchBy: "DealerId" }));
            if (actionType === 'Edit') {
                getSyncedData(__assign(__assign({}, rowData), { ProgramNames: __programIds, SearchBy: "DealerId" }));
            }
        }
    }, [actionType]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: 'Are you sure?', message: "Are you sure you want to ".concat(userAction !== 'Create' ? 'update' : 'create', " the Dealer Program Association?"), acceptBtnText: 'Yes', denyBtnText: 'No', acceptCallBack: useCallback(function () {
                if (userAction !== 'Create') {
                    handleUpdateAdmin();
                }
                else {
                    handleCreateDealerProgramAssociation();
                }
                setOpenConfirmationPopup(false);
            }, [openConfirmationPopup]), denyCallBack: useCallback(function () {
                setOpenConfirmationPopup(false);
            }, []), open: openConfirmationPopup, key: "".concat(openConfirmationPopup), cancelCallBack: useCallback(function () {
                setOpenConfirmationPopup(false);
            }, []) }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.SUCCESS_ALERT, titleText: 'Success!', message: "Dealer Program Association has been ".concat(userAction !== 'Create' ? 'updated' : 'created', " successfully."), acceptBtnText: 'Ok', acceptCallBack: useCallback(function () {
                setOpenSuccessPopup(false);
                handleDrawerClose();
                DealerProgramAssociationList();
            }, [openConfirmationPopup]), open: openSuccessPopup, key: "".concat(openSuccessPopup) }),
        React.createElement(Dialog, { open: open, className: 'MuiDialogue-upload location-popup' },
            React.createElement(DialogTitle, { sx: { m: 0, p: 2 }, id: "customized-dialog-title" }, actionType === 'View' ? 'View Dealer - Program' : "".concat(actionType, " Dealer - Program")),
            React.createElement(IconButton, { "aria-label": "close", onClick: function () { return handleDrawerClose(); }, className: 'popup-close', sx: {
                    position: 'absolute',
                    right: 8,
                    top: 8,
                } },
                React.createElement(CloseIcon, null)),
            React.createElement(DialogContent, { sx: { paddingTop: '0px' } },
                actionType != 'View' &&
                    React.createElement(Box, null,
                        React.createElement(FormControl, null,
                            React.createElement(FormLabel, { id: "demo-row-radio-buttons-group-label", sx: { color: '#000' } }, "Search by"),
                            React.createElement(RadioGroup, { row: true, "aria-labelledby": "demo-row-radio-buttons-group-label", sx: { padding: '16px 0px' }, name: "SearchBy", value: dealerProgramInfo.SearchBy, onChange: function (e) { return handleNewLocationInfoChange(e); } },
                                React.createElement(FormControlLabel, { value: "DealerId", control: React.createElement(Radio, null), label: "DEALER ID" }),
                                React.createElement(FormControlLabel, { value: "DealerOId", control: React.createElement(Radio, null), label: "DEALER OID" })))),
                actionType === 'Edit' &&
                    React.createElement(Box, { bgcolor: '#0e0e1333', borderRadius: '4px', padding: '4px 8px', marginBottom: '8px' },
                        React.createElement(Box, { sx: { cursor: 'pointer' }, display: 'flex', alignItems: 'center', justifyContent: isSyncing ? 'center' : 'flex-end', onClick: getSyncedData },
                            React.createElement(IconButton, { sx: { padding: '0px' } },
                                React.createElement(SyncOutlinedIcon, null)),
                            React.createElement(Typography, { padding: '0px 4px', fontSize: '14px' }, isSyncing ? 'Currently syncing the latest details from Aspire' : 'Sync again'))),
                actionType === 'View' ?
                    React.createElement(Grid, { container: true, rowSpacing: 3, columnSpacing: { xs: 1, sm: 2, md: 0 } },
                        React.createElement(Grid, { item: true, xs: 12, style: { borderBottom: '1px #E6E6E6 solid' } },
                            React.createElement(Grid, { style: { padding: '5px', borderBottom: 'light grey' } },
                                React.createElement(Typography, { className: 'view-page-labels' }, "Dealer ID"),
                                React.createElement(Typography, { className: 'view-page-values' }, rowData === null || rowData === void 0 ? void 0 : rowData.DealerAccountAspireId))),
                        React.createElement(Grid, { item: true, xs: 12, style: { borderBottom: '1px #E6E6E6 solid' } },
                            React.createElement(Grid, { style: { padding: '5px', borderBottom: 'light grey' } },
                                React.createElement(Typography, { className: 'view-page-labels' }, "Dealer OID"),
                                React.createElement(Typography, { className: 'view-page-values' }, rowData === null || rowData === void 0 ? void 0 : rowData.DealerAccountAspireOId))),
                        React.createElement(Grid, { item: true, xs: 12, style: { borderBottom: '1px #E6E6E6 solid' } },
                            React.createElement(Grid, { style: { padding: '5px', borderBottom: 'light grey' } },
                                React.createElement(Typography, { className: 'view-page-labels' }, "Dealer Name"),
                                React.createElement(Typography, { className: 'view-page-values' }, rowData === null || rowData === void 0 ? void 0 : rowData.DealerName))),
                        (rowData === null || rowData === void 0 ? void 0 : rowData.ActivationCode) &&
                            React.createElement(Grid, { item: true, xs: 12, style: { borderBottom: '1px #E6E6E6 solid' } },
                                React.createElement(Grid, { style: { padding: '5px', borderBottom: 'light grey' } },
                                    React.createElement(Typography, { className: 'view-page-labels' }, "Activation Code"),
                                    React.createElement(Typography, { className: 'view-page-values' }, rowData === null || rowData === void 0 ? void 0 : rowData.ActivationCode))),
                        (rowData === null || rowData === void 0 ? void 0 : rowData.Status) &&
                            React.createElement(Grid, { item: true, xs: 12, style: { borderBottom: '1px #E6E6E6 solid' } },
                                React.createElement(Grid, { style: { padding: '5px', borderBottom: 'light grey' } },
                                    React.createElement(Typography, { className: 'view-page-labels' }, "Status"),
                                    React.createElement(Typography, { className: 'view-page-values' }, rowData === null || rowData === void 0 ? void 0 : rowData.Status))),
                        React.createElement(Grid, { item: true, xs: 12, style: { borderBottom: '1px #E6E6E6 solid' } },
                            React.createElement(Grid, { style: { padding: '5px', borderBottom: 'light grey' } },
                                React.createElement(Typography, { className: 'view-page-labels' }, "Programs"), (_c = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.ProgramNames) === null || _b === void 0 ? void 0 : _b.split(',')) === null || _c === void 0 ? void 0 :
                                _c.map(function (program, index) { return (React.createElement(Typography, { className: 'view-page-values' }, "".concat(index + 1, ". ").concat(program))); }))))
                    :
                        React.createElement(Grid, { container: true, rowSpacing: 3, columnSpacing: { xs: 1, sm: 2, md: 3 } },
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(TextField, { key: rerender, label: 'Dealer ID', name: 'DealerAccountAspireId', isMandatoryField: true, placeholder: 'Dealer ID', fullWidth: true, disabled: dealerProgramInfo.SearchBy == 'DealerOId', value: dealerProgramInfo === null || dealerProgramInfo === void 0 ? void 0 : dealerProgramInfo.DealerAccountAspireId, onChange: handleNewLocationInfoChange, onBlur: handleOnInputBlur, error: Boolean(errors.DealerAccountAspireId), error_message: errors.DealerAccountAspireId, type: "text" })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(TextField, { key: rerender, label: 'Dealer OID', name: 'DealerAccountAspireOId', isMandatoryField: true, placeholder: 'Dealer OID', fullWidth: true, disabled: dealerProgramInfo.SearchBy == 'DealerId', value: dealerProgramInfo.DealerAccountAspireOId, onChange: handleNewLocationInfoChange, onBlur: handleOnInputBlur, error: Boolean(errors.DealerAccountAspireOId), error_message: errors.DealerAccountAspireOId, type: "text" })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(TextField, { key: rerender, label: 'Dealer Name', name: 'DealerName', isMandatoryField: true, placeholder: 'Dealer Name', fullWidth: true, disabled: true, value: dealerProgramInfo.DealerName, onChange: handleNewLocationInfoChange, onBlur: handleOnInputBlur, error: Boolean(errors.DealerName), error_message: errors.DealerName, type: "text" })),
                            (actionType === 'Edit' && (dealerProgramInfo === null || dealerProgramInfo === void 0 ? void 0 : dealerProgramInfo.Status)) &&
                                React.createElement(Grid, { item: true, xs: 12 },
                                    React.createElement(Typography, { className: 'view-page-labels' }, "STATUS"),
                                    React.createElement(Typography, { className: 'view-page-values', pb: '0 !important' }, dealerProgramInfo === null || dealerProgramInfo === void 0 ? void 0 : dealerProgramInfo.Status)),
                            actionType === 'Edit' &&
                                React.createElement(Grid, { item: true, xs: 12 },
                                    React.createElement(Typography, { className: 'view-page-labels' }, "ACTIVATION CODE"),
                                    React.createElement(Typography, { className: 'view-page-values', pb: '0 !important' }, (_d = dealerProgramInfo === null || dealerProgramInfo === void 0 ? void 0 : dealerProgramInfo.ActivationCode) !== null && _d !== void 0 ? _d : '--')),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(AutoCompleteMultiSelectDD, { key: rerender, options: programsList, displayKey: 'label', valueKey: 'value', label: 'Programs', placeholder: 'Select', handleChange: handleSelectionChange, selectedValue: dealerProgramInfo.ProgramNames, name: "ProgramNames", errorMessage: errors.ProgramNames, isMandatoryField: true, handleBlur: handleOnInputBlur })))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { variant: 'outlined', onClick: function () { return handleDrawerClose(); }, size: 'small', className: 'btn-txt' }, actionType === 'Edit' ? 'Cancel' : 'Close'),
                (actionType && actionType !== 'View' || canUpdate) && (React.createElement(Button, { variant: 'contained', onClick: function () { return handleClick(); }, size: 'small', className: 'btn-txt' }, getButtonText()))))));
};
export default DealerProgramAssocation;
